const ROL = {
  ADMINISTRADOR: 'ADMINISTRADOR',
  RESPONSABLE: 'RESPONSABLE',
  DENUNCIANTE: 'DENUNCIANTE',
  AUTORIDAD: 'AUTORIDAD',
};

const ROLES = [
  { id: ROL.ADMINISTRADOR, desc: 'Administrador' },
  { id: ROL.RESPONSABLE, desc: 'Gestor' },
  { id: ROL.DENUNCIANTE, desc: 'Denunciante' },
  { id: ROL.AUTORIDAD, desc: 'Autoridad' },
];
export { ROL, ROLES };
